import {createContext} from 'react';
import {noop} from 'lodash';
import type {NumberInputContextProps} from '../_types';
import {NUMBER_INPUT_VARIANTS} from '../_constants';

export const NumberInputContext = createContext<NumberInputContextProps>({
  state: {
    _currentValue: undefined,
    isDisabled: false,
    isScrubbing: false,
    isError: false,
    isFocused: false,
    isMin: false,
    isMax: false,
    max: Number.MAX_SAFE_INTEGER,
    min: Number.MIN_SAFE_INTEGER,
    name: '',
    placeholder: '',
    prefix: undefined,
    ref: () => null,
    shouldAllowWheelAdjustment: true,
    shouldShowTrailingControls: false,
    step: 1,
    suffix: undefined,
    variant: NUMBER_INPUT_VARIANTS.DEFAULT,
  },
  handlers: {
    onBlur: noop,
    onFocus: noop,
    onChange: noop,
    onKeyDown: noop,
    onScrubChange: noop,
    onSetIsScrubbing: noop,
    onStepClick: noop,
  },
});
